const WARN = "WARN";
const ERROR = "ERROR";
export const alertLevelCssClasses = (alert: string) => {
  if (alert === WARN) {
    return "warning";
  } else if (alert === ERROR) {
    return "danger";
  } else {
    return "light";
  }
};